import { createRoutine } from '../common/utils/routines.js';

export const login = createRoutine('netlifyAddon/LOGIN');
